import { render, staticRenderFns } from "./ForumBottomNav.vue?vue&type=template&id=fc9c9696&scoped=true"
import script from "./ForumBottomNav.vue?vue&type=script&lang=js"
export * from "./ForumBottomNav.vue?vue&type=script&lang=js"
import style0 from "./ForumBottomNav.vue?vue&type=style&index=0&id=fc9c9696&prod&lang=scss&scoped=true"
import style1 from "./ForumBottomNav.vue?vue&type=style&index=1&id=fc9c9696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9c9696",
  null
  
)

export default component.exports